<template>
  <div>
    <div style="width: 100%; text-align: center">
      <img :src="`https://s3.amazonaws.com/cdn.ats-ptrac.com/wait-gif/wait-${Math.floor(Math.random() * 9)}.gif`"/>
      <h3 style="margin-top: 15px;">{{ data.message }}</h3>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['data'],
    methods: {
      close() {
        this.$emit('close')
      }
    },
    mounted() {
      this.$eventHub.$on('closePleaseWait', this.close)
      setTimeout(() => {
        this.close()
      }, this.data.seconds)
    }
  }
</script>
